import React from "react";
import './Torneo.css'; // usa lo stesso stile

export default function EventoDetail({ nome, descrizione, immagini = [] }) {
  return (
    <div className="torneo-container">
      <h1 className="torneo-title">{nome}</h1>
      <p className="torneo-description">{descrizione}</p>
      {immagini.length > 0 && (
        <div className="torneo-gallery">
          {immagini.map((img, idx) => (
            <img key={idx} src={img} alt={`${nome} ${idx}`} className="torneo-image" />
          ))}
        </div>
      )}
    </div>
  );
}
